import styled from 'styled-components';
import { Dialog } from '@mui/material';
import { COLOR } from '@src/styles/color';
import introduceVbeeEdu from '@src/assets/images/introduce-vbee-edu.svg';

export const StyledDialog = styled(Dialog)`
  .video-container {
    height: 389px;
    overflow: hidden;
    padding: 24px;
    background-color: #f4f5f7;
    border-bottom: 1px solid ${COLOR.indigo[16]};
    iframe {
      width: 100%;
      height: 100%;
      border-radius: 16px;
      overflow: hidden;
      border: none;
    }
  }

  .video-container iframe {
    width: 100%;
    height: 100%;
    border-radius: 16px;
    overflow: hidden;
  }

  .content-container {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 32px 32px 16px 32px;
  }

  .MuiDialog-paper {
    border-radius: 16px;
    max-width: ${({ width }) => width || '740px'};
    width: ${({ width }) => width || '740px'};
    margin: 0;
  }

  .dialog-content {
    padding: 0px;
    display: flex;
    flex-direction: column;
    overflow-x: ${({ styleContent }) => styleContent?.overflowX};
  }

  .dialog-actions {
    padding: 0 32px 32px 32px;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .new-label {
    background-color: ${COLOR.tagNew};
    padding: 4px 8px;
    border-radius: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .beta-label {
    background-color: rgba(0, 122, 255, 0.08);
    padding: 4px 8px;
    border-radius: 480px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .content-container-header {
    display: flex;
    // justify-content: space-between;
    align-items: center;
    gap: 10px;
  }

  /* Vbee for Educators welcome popup */
  &.educators-popup .MuiDialog-paper {
    width: 640px;
    max-width: 640px;
    border-radius: 24px;
    box-shadow: 0px 4px 16px 0px ${COLOR.boxShadow};
    overflow: hidden;
  }
  /* Insets the banner so it reads as a card, and separates it from the text. */
  .educators-banner-section {
    padding: 12px;
    background-color: ${COLOR.charcoal};
    border-bottom: 0.5px solid ${COLOR.indigo[16]};
  }
  .educators-banner {
    position: relative;
    width: 100%;
    box-sizing: border-box;
    aspect-ratio: 616 / 291;
    background-image: url(${introduceVbeeEdu});
    background-origin: border-box;
    background-size: 100% 100%;
    border-radius: 16px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 0 40px;
  }
  .educators-beta {
    position: absolute;
    top: 12px;
    right: 12px;
    padding: 4px 12px;
    border-radius: 16px;
    border: 1px solid ${COLOR.white};
    background-color: rgba(255, 255, 255, 0.04);
    backdrop-filter: blur(1px);
    display: flex;
    height: 24px;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
  }
  .educators-banner-text {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
  }
  .educators-body {
    display: flex;
    flex-direction: column;
    gap: 16px;
    /* No padding below: the 16px gap plus the actions' own 12px make up the
       28px the design leaves above the button. */
    padding: 24px 24px 16px;
  }
  .educators-intro {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding-bottom: 8px;
  }
  .educators-features {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 8px;
  }
  /* The design draws these 28px tall with 8px of padding, which a 16px icon
     cannot fit inside. The height is what its rows measure, so the padding
     applies across only. */
  .educators-feature {
    display: flex;
    align-items: center;
    gap: 8px;
    height: 28px;
    min-width: 128px;
    padding: 0 8px;
    border-radius: 6px;
  }
  /* The design carries the arrow inside the label, where it reads as a space
     rather than another gap in the row. */
  .educators-feature-label {
    display: flex;
    align-items: center;
    gap: 4px;
    min-width: 0;
  }
  .educators-feature-icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
  }
  .educators-feature-arrow {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    color: ${COLOR.midSlate};
  }
  &.educators-popup .dialog-actions {
    padding: 12px 24px 24px;
    gap: 16px;
  }
`;
